import React from "react";
import clientsStore from "./clientsStore";

class RootStore {
  constructor() {
    this.clientsStore = new clientsStore(this);
  }
}

const StoresContext = React.createContext(new RootStore());

export const useStores = () => React.useContext(StoresContext);

export const StoresProvider = ({ children }) => {
  const [stores] = React.useState(() => new RootStore());
  return (
    <StoresContext.Provider value={stores}>{children}</StoresContext.Provider>
  );
};
